import React, { useState, useRef } from 'react';
import { Helmet } from 'react-helmet';
import { FaPhoneAlt, FaWhatsapp, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import emailjs from '@emailjs/browser';
import ReactGA from "react-ga4"; 
import { ContactContainer, ContactHero, ContactContent, ContactForm, FormGroup, Input, TextArea, Select, SubmitButton, ContactInfo, } from './estilosContact';


function Contact() {
  const form = useRef();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    service: '',
    subject: '',
    message: ''
  });
  
  const [submitStatus, setSubmitStatus] = useState({
    submitting: false,
    success: false,
    error: false,
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    setSubmitStatus({
      submitting: true,
      success: false,
      error: false,
      message: 'Enviando mensaje...'
    });

    // Registrar el evento de envío de formulario
    ReactGA.event({
      category: "Formulario",
      action: "Envío",
      label: `Servicio: ${formData.service}`,
    });

    // Reemplaza estos IDs con tus credenciales reales de EmailJS
    emailjs.sendForm(
      'service_ibnqj0x', 
      'template_ape0rpi', 
      form.current, 
      '2srlE2E1nPBmR73E2'
    )
    .then((result) => {
      console.log('Email enviado con éxito!', result.text);
      setFormData({
        name: '',
        email: '',
        service: '',
        subject: '',
        message: ''
      });
      setSubmitStatus({
        submitting: false,
        success: true,
        error: false,
        message: '¡Mensaje enviado con éxito! Nos pondremos en contacto contigo pronto.'
      });
    }, (error) => {
      console.log('Error al enviar el email:', error.text);
      setSubmitStatus({
        submitting: false,
        success: false,
        error: true,
        message: 'Hubo un problema al enviar tu mensaje. Por favor, inténtalo de nuevo.'
      });
    });
  };

  return (
    <ContactContainer>
      <Helmet>
        <title>Hablemos sobre tu próximo proyecto digital | Juanfra Hernández</title>
        <meta name="description" content="¿Tienes una idea o proyecto? Estoy listo para ayudarte a llevarlo al siguiente nivel con soluciones digitales a medida. Escríbeme sin compromiso." />
        <link rel="canonical" href="https://juanfrahernandez.es/contacto" />
      </Helmet>

      <ContactHero>
        <video autoPlay muted loop playsInline>
          <source src="https://videos.pexels.com/video-files/28561463/12421438_2560_1440_30fps.mp4" type="video/mp4" />
        </video>
        <h1>Contacto</h1>
      </ContactHero>

      <ContactContent>
        <ContactForm ref={form} onSubmit={handleSubmit}>
          <FormGroup>
            <label htmlFor="name">Nombre</label>
            <Input 
              type="text" 
              id="name" 
              name="name" 
              value={formData.name}
              onChange={handleChange}
              required 
            />
          </FormGroup>
          
          <FormGroup>
            <label htmlFor="email">Email</label>
            <Input 
              type="email" 
              id="email" 
              name="email" 
              value={formData.email}
              onChange={handleChange}
              required 
            />
          </FormGroup>
          
          <FormGroup>
            <label htmlFor="service">Servicio de interés</label>
            <Select 
              id="service" 
              name="service"
              value={formData.service}
              onChange={handleChange}
              required
            >
              <option value="">Selecciona un servicio</option>
              <option value="Desarrollo Web">Desarrollo Web</option>
              <option value="E-commerce">E-commerce</option>
              <option value="SEO">SEO</option>
              <option value="Diseño Gráfico">Diseño Gráfico</option>
              <option value="Redes Sociales">Redes Sociales</option>
              <option value="Otro">Otro</option>
            </Select>
          </FormGroup>
          
          <FormGroup>
            <label htmlFor="subject">Asunto</label>
            <Input 
              type="text" 
              id="subject" 
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              required 
            />
          </FormGroup>
          
          <FormGroup>
            <label htmlFor="message">Mensaje</label>
            <TextArea 
              id="message" 
              name="message"
              value={formData.message}
              onChange={handleChange}
              required 
            />
          </FormGroup>
          
          <SubmitButton 
            type="submit" 
            disabled={submitStatus.submitting}
          >
            {submitStatus.submitting ? 'Enviando...' : 'Enviar Mensaje'}
          </SubmitButton>
          
          {submitStatus.success && (
            <div style={{ 
              marginTop: '1rem', 
              padding: '0.8rem', 
              backgroundColor: '#d4edda', 
              color: '#155724',
              borderRadius: '5px',
              textAlign: 'center'
            }}>
              {submitStatus.message}
            </div>
          )}
          
          {submitStatus.error && (
            <div style={{ 
              marginTop: '1rem', 
              padding: '0.8rem', 
              backgroundColor: '#f8d7da', 
              color: '#721c24',
              borderRadius: '5px',
              textAlign: 'center'
            }}>
              {submitStatus.message}
            </div>
          )}
        </ContactForm>

        <ContactInfo>
          <h3>Información de Contacto</h3>
          <div className="map-container">
            <iframe
              title="Ubicación"
              src="https://www.google.com/maps?q=Calle+San+Benito+3,+04738+Vicar&output=embed"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
          
          <div style={{ 
            display: "flex", 
            justifyContent: "center", 
            gap: "1.5rem", 
            marginTop: "2rem" 
          }}>
            <a
              href="https://www.google.com/maps?q=Calle+San+Benito+3,+04738+Vicar"
              target="_blank"
              rel="noopener noreferrer"
              title="Ver ubicación en Google Maps"
              style={{
                background: "#f5f5f5",
                borderRadius: "50%",
                width: "48px",
                height: "48px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "1.6rem",
                boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
                transition: "transform 0.3s, background 0.3s"
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.background = "#f0f0f0";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.background = "#f5f5f5";
              }}
            >
              <FaMapMarkerAlt style={{ color: "#e74c3c" }} />
            </a>
            <a
              href="tel:+34604831012"
              title="Llamar por teléfono"
              style={{
                background: "#f5f5f5",
                borderRadius: "50%",
                width: "48px",
                height: "48px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "1.6rem",
                boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
                transition: "transform 0.3s, background 0.3s"
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.background = "#f0f0f0";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.background = "#f5f5f5";
              }}
            >
              <FaPhoneAlt style={{ color: "#007bff" }} />
            </a>
            <a
              href="https://wa.me/34604831012?text=Me%20gustaria%20obtener%20informacion%20sobre%20un%20servicio"
              target="_blank"
              rel="noopener noreferrer"
              title="Contactar por WhatsApp"
              style={{
                background: "#f5f5f5",
                borderRadius: "50%",
                width: "48px",
                height: "48px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "1.6rem",
                boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
                transition: "transform 0.3s, background 0.3s"
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.background = "#f0f0f0";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.background = "#f5f5f5";
              }}
            >
              <FaWhatsapp style={{ color: "#25d366" }} />
            </a>
            <a
              href="mailto:info@juanfrahernandez.es"
              title="Enviar correo"
              style={{
                background: "#f5f5f5",
                borderRadius: "50%",
                width: "48px",
                height: "48px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "1.6rem",
                boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
                transition: "transform 0.3s, background 0.3s"
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.background = "#f0f0f0";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.background = "#f5f5f5";
              }}
            >
              <FaEnvelope style={{ color: "#e67e22" }} />
            </a>
          </div>
          <div style={{ textAlign: "center", marginTop: "1.5rem" }}>
            <span>⏰ Lunes a Viernes: 9:30 - 16:00</span>
          </div>
        </ContactInfo>
      </ContactContent>
    </ContactContainer>
  );
}

export default Contact;